import classNames from 'classnames';

import HomePageBlocks, { HomePageBlocksProps } from './HomePageBlocks';

import styles from '../../styles/pages/home-page-periodelibre.module.css';

function HomePagePeriodelibre({ brand, className = null, ...props }: HomePageBlocksProps) {
    return (
        <HomePageBlocks
            {...props}
            withoutSeries
            brand={brand}
            className={classNames([styles.container, className])}
            blocksClassName={styles.blocks}
        />
    );
}

export default HomePagePeriodelibre;
